import { updateClock, playChime } from "./clock"
import { updatePhoneticTime } from "./phoneticTime"
import { getIsMuted, getVolumeIcon, setIsMuted } from "./settings"

getVolumeIcon()?.addEventListener("click", () => {
  setIsMuted(!getIsMuted())
})

new Audio("./silence.mp3").play()

const initialDate = new Date()
updatePhoneticTime(initialDate)
updateClock(initialDate)
setIsMuted(getIsMuted())

setTimeout(() => {
  document.getElementById("volume-settings")?.classList.remove("volume-settings-initial")
}, 5000)

let prevMinutes = 60

setInterval(() => {
  const currentDate = new Date()
  const currentMinutes = currentDate.getMinutes()

  updateClock(currentDate)

  if (currentMinutes !== prevMinutes) {
    updatePhoneticTime(currentDate)

    if (currentMinutes === 0) {
      playChime()
    }

    prevMinutes = currentMinutes
  }
})
